module.exports = __webpack_public_path__ + "img/agreement-pic-old.14389ff8.png";